import { useLang } from "@/lib/lang";
import React from "react";
import { Phone, MessageSquare, DoorOpen } from "lucide-react";
import { useEmergency } from "@/components/EmergencyProvider";

export const quickExit = () => {
  try {
    window.location.replace("https://www.google.com");
    window.open("https://weather.com", "_blank");
  } catch (e) {
    window.location.href = "https://www.google.com";
  }
};

export const CrisisBanner = () => {
  const { lang } = useLang();
  const { open } = useEmergency();
  return (
    <div className="relative z-[60] bg-bsn-midnight text-bsn-parchment border-b border-bsn-gold/30" data-testid="crisis-banner">
      <div className="max-w-7xl mx-auto px-4 py-2 flex flex-wrap items-center justify-center sm:justify-between gap-x-4 gap-y-2 text-center sm:text-left">
        <div className="flex items-center gap-2 text-xs sm:text-sm">
          <span className="w-2 h-2 rounded-full bg-emerald-400 beacon-dot shrink-0" aria-hidden="true" />
          <span className="font-mono tracking-tight">
            {lang === "es" ? "Apoyo en crisis 24/7, confidencial —" : "24/7 Confidential Crisis Support —"}
          </span>
          <a href="tel:988" className="inline-flex items-center gap-1 font-semibold text-bsn-champagne hover:text-bsn-gold transition-colors" data-testid="crisis-banner-988-call">
            <Phone className="w-3.5 h-3.5" /> {lang === "es" ? "Llama al 988 (presiona 2)" : "Call or Text 988"}
          </a>
          <span className="text-bsn-ice/40 hidden sm:inline">•</span>
          <a href="tel:18664887386" className="hidden sm:inline-flex items-center gap-1 font-semibold text-bsn-champagne hover:text-bsn-gold transition-colors" data-testid="crisis-banner-trevor-call">
            <MessageSquare className="w-3.5 h-3.5" /> Trevor Project 1-866-488-7386
          </a>
        </div>
        <div className="flex items-center gap-2">
          <button
            onClick={open}
            className="text-xs font-semibold px-3 py-1 rounded-full border border-bsn-gold/50 hover:bg-bsn-gold hover:text-bsn-midnight transition-colors"
            data-testid="crisis-banner-more"
          >
            {lang === "es" ? "Más líneas de apoyo" : "More Support Lines"}
          </button>
          <button
            onClick={quickExit}
            className="inline-flex items-center gap-1 text-xs font-semibold px-3 py-1 rounded-full bg-bsn-parchment text-bsn-midnight hover:bg-bsn-gold transition-colors"
            title="Instantly leave this site"
            data-testid="quick-exit-button"
          >
            <DoorOpen className="w-3.5 h-3.5" /> {lang === "es" ? "Salida rápida" : "Quick Exit"}
          </button>
        </div>
      </div>
    </div>
  );
};

export default CrisisBanner;
